import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout } from "antd";
import { LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";
import { getMemberDigitalApi } from "../../services/Member/MemberApis";

const { Content } = Layout;

const MemberSuccessPage: React.FC = () => {
  const { memberId }: any = useParams();

  const [isActive, setActive] = useState(true);
  const [member, setMember] = useState<any>({});

  useEffect(() => {
    getMemberDigitalApi(String(memberId))
      .then((res: any) => {
        setMember(res.data);
        setActive(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [memberId]);

  return (
    <LoadingOverlay active={isActive} spinner={<LoadingOutlined />}>
      <Layout style={{ minHeight: "100vh" }}>
        <Layout className="site-layout">
          <Content
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              background: "#fff",
              padding: "24px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                width: "100%",
                maxWidth: "500px",
                padding: "16px",
                boxSizing: "border-box",
              }}
            >
              {member.Group?.CompanyLogo && (
                <img
                  src={member.Group.CompanyLogo}
                  alt="Group Logo"
                  style={{
                    marginBottom: "24px",
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              )}
              <CheckCircleOutlined
                style={{
                  color: "green",
                  fontSize: "48px",
                  marginBottom: "16px",
                }}
              />
              <h3
                style={{
                  marginBottom: "24px",
                  padding: "0 16px",
                  fontSize: "1.1em",
                  lineHeight: "1.5",
                }}
              >
                Thank you! Your application has been successfully submitted. We
                appreciate your trust in {member?.Group?.GroupName} for your
                funeral policy needs. You’ll receive a confirmation shortly.
              </h3>
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default MemberSuccessPage;
